export default __webpack_public_path__ + "static/media/system1.bac1d16d.png";